<template>
    <div class="avatar-cropper">
        <el-dialog title="" class="cropper-dialog" v-model="dialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close width="600px">
            <div class="avatar-container">
                <!-- 待上传图片 -->
                <div v-show="!options.img">
                    <el-upload class="upload" ref="elUpload" action="#" :on-change="upload" accept="image/png, image/jpeg, image/jpg,image/svg+xml" :show-file-list="false" :auto-upload="false">
                        <el-button slot="trigger" type="success" ref="uploadBtn">Select Picture</el-button>
                    </el-upload>
                </div>
                <!-- <img :src="options.img" alt=""> -->
                <!-- 已上传图片 -->
                <div v-show="options.img" class="avatar-crop">
                    <vueCropper class="crop-box" ref="cropper" :img="options.img" :info="options.info" :autoCrop="options.autoCrop" :fixedBox="options.fixedBox" :canMoveBox="options.canMoveBox" :autoCropWidth="options.autoCropWidth" :autoCropHeight="options.autoCropHeight" :centerBox="options.centerBox" :fixed="options.fixed" :fixedNumber="options.fixedNumber" :canMove="options.canMove" :canScale="options.canScale"></vueCropper>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <div class="reupload" @click="reupload">
                        <span v-show="options.img">Re-upload</span>
                    </div>
                    <div class="dialog-btns">
                        <el-button size="large" @click="closeDialog">Back</el-button>
                        <el-button size="large" type="success" @click="getCrop">Save</el-button>
                    </div>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script lang="ts">
import axios from 'axios';
import { uploadFile } from '@/api/auth.js';
import { ref, reactive, defineComponent } from 'vue';
import { VueCropper } from 'vue-cropper';
import 'vue-cropper/dist/index.css';
import type { UploadProps, UploadUserFile } from 'element-plus';
import { ElMessage } from 'element-plus';
export default defineComponent({
    props: {
        dialogVisible: {
            type: Boolean
        },
        circleType: {
            type: String,
            default: '1'
        }
    },
    components: {
        VueCropper
    },

    setup(props, { emit }) {
        // console.log(11111);
        const cropper = ref();
        const uploadBtn = ref();
        const elUpload = ref();
        const options = reactive({
            img: '', // 原图文件
            imgName: '', // 原图文件名
            info: false, // 是否显示裁剪信息
            cropperImg: '', // 裁剪后的图片
            autoCrop: true, // 默认生成截图框
            fixedBox: false, // 固定截图框大小
            canMoveBox: true, // 截图框可以拖动
            autoCropWidth: 300, // 截图框宽度
            autoCropHeight: 300, // 截图框高度
            fixed: true, // 截图框宽高固定比例
            fixedNumber: [1, 1], // 截图框的宽高比例
            centerBox: true, // 截图框被限制在图片里面
            canMove: false, // 上传图片不允许拖动
            canScale: true // 上传图片不允许滚轮缩放
        });
        // vueCropper组件 裁剪配置信息

        // 读取原图
        const upload: UploadProps['onChange'] = (file: any, uploadFiles) => {
            // console.log(file);
            options.imgName = file.name; // 获取文件名
            const isIMAGE = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png' || file.raw.type === 'image/jpg' || file.raw.type === 'image/svg+xml';
            const isLt2M = file.raw.size / 1024 / 1024 < 2;
            if (!isIMAGE) {
                ElMessage.warning(' picture must be JPG, JPEG, PNG, or SVG format!');
                return false;
            }
            if (!isLt2M) {
                ElMessage.warning(' picture size can not exceed 2MB!');
                return false;
            }
            let reader = new FileReader();

            reader.readAsDataURL(file.raw);
            //console.log(reader);

            reader.onload = (e: any) => {
                options.img = e.target.result; // base64
            };
            elUpload.value.clearFiles(); //这里处理重新上传时，upload组件change事件错误问题
        };
        // 获取截图信息
        const getCrop = () => {
            // 获取截图的 base64 数据
            cropper.value.getCropData((data: any) => {
                // console.log(data);
                options.cropperImg = data; // base64
            });

            // 获取截图的 blob 数据
            //console.log(cropper.value);
            cropper.value.getCropBlob((data: any) => {
                let formData = new FormData();
                formData.append('file', data, options.imgName);
                // for (const [key, value] of formData.entries()) {
                //     console.log(key, value);
                // }
                //上传接口
                axios
                    .post(process.env.VUE_APP_BASE_API + '/api/v1/file', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        // console.log(response);
                        if (response.data.code === 200) {
                            ElMessage.success('Upload successful!');
                            // options.cropperImg = response.data.data; // 更新裁剪后的图片地址
                            closeDialog(response.data.data.id); // 关闭弹框并传递裁剪后的图片地址
                        } else {
                            ElMessage.error('Upload failed: ' + response.data.msg);
                        }
                    })
                    .catch(error => {
                        console.error('Upload error:', error);
                        ElMessage.error('Upload failed!');
                    });
            });
        };
        // 重新上传
        const reupload = () => {
            ////
            // console.log(uploadBtn.value.ref);

            uploadBtn.value.ref.click();
        };
        // 关闭弹框
        const closeDialog = (id: string) => {
            emit('closeAvatarDialog', options.cropperImg, id, props.circleType);
            options.img = '';
        };
        return {
            options,
            cropper,
            uploadBtn,
            elUpload,
            upload,
            getCrop,
            reupload,
            closeDialog
        };
    }
});
</script>

<style lang="scss" scoped>
.avatar-cropper {
    ::v-deep .el-overlay {
        background: #ffffff80;
        backdrop-filter: blur(20px);
    }
    ::v-deep .cropper-dialog {
        background: none;
        box-shadow: none;
    }
}

.dialog-footer {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding-top: 30px;
    .reupload {
        color: #b120b2;
        cursor: pointer;
    }

    .dialog-btns {
        position: absolute;
        left: 50%;
        top: 20px;
        transform: translateX(-50%);
    }
}

.avatar-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 560px;
    height: 350px;
    background: #00000080;
    margin-right: 10px;
    border-radius: 4px;
    .upload {
        text-align: center;
        margin-bottom: 24px;
    }
    .avatar-crop {
        width: 560px;
        height: 350px;
        position: relative;
        .crop-box {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            overflow: hidden;
            ::v-deep .cropper-face,
            ::v-deep .cropper-view-box {
                border-radius: 50%; /* 使裁剪框的四边和点都为圆角 */
            }

            ::v-deep .crop-line,
            ::v-deep .crop-point {
                display: none; /* 隐藏裁剪框的线条和点 */
            }
        }
    }
}
</style>
